import { Image } from '../../../shared/shared.interface';

export interface KngUploadFile {
    state: KngUploadFileState;
}
export interface KngUploadFileState {
    isLoading: boolean;
    dragDropSection: string;
    or: string;
    uploadButtons: UploadButtons;
    isError: boolean;
    isSuccessClient: boolean;
    isSuccessServer: boolean;
    errorHeading: string;
    errorSubHeading: string;
    successMessage: string;
    dragDropImage: Image;
    errorImage: Image;
    successImage: Image;
    fileUploadLoader: boolean;
    fileUploadProgressText: string;
}

export interface UploadFileSection {
    onLoadIcon: Image;
    errorIcon: Image;
    successIcon: Image;
    dragDropLabel: string;
    orLabel: string;
    uploadButtons: UploadButtons;
    success: string;
}
export interface UploadButtons {
    chooseFile: string;
    replaceFile: string;
    tryAgain: string;
}

export enum ErrorMessageSubHeading {
    wrongFormat = 'Check to ensure file is in .XLSX format. Please check format and try again.',
    sizeExceed = 'File size must not exceed 100 MB. Please check the file and try again.',
    apiFailure = 'API failure, try again later.',
    wrongData = 'Please ensure the data in the file is in the correct format and try again, and at a minimum the Location GRID and TopLevel GRID must be entered.',
    apiError = 'Something went wrong, please try again.',
    templateMismatch = 'Your file does not match the template. Please replace the file and try again.',
    incorrectSize = 'File size must not exceed 100 MB. Please check the file and try again.',
    emptyFile = 'It looks like the file you uploaded is empty. Please check the file and try again.'
}

export enum ErrorMessageHeading {
    uploadFailed = 'Upload Failed',
    sizeExceed = 'File Size Exceeded',
    emptyFile = 'Empty File Uploaded',
    wrongData = 'Uploaded with No Locations or Incorrect Data Format'
}
